import React, { useState, useEffect } from 'react';
import { listCourses } from '../../Services/courseService';
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from 'react-i18next';
import CourseTemplate from '../CourseSections/CourseTemplate';
import { Helmet } from "react-helmet-async";
import './Courses.css';

const PremiumCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const [message, setMessage] = useState();

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const response = await listCourses();
        const filteredCourses = response?.data?.data?.filter(course => course.price >= 500) || [];
        setCourses(filteredCourses);
        setMessage(response?.data?.message);
      } catch (error) {
        setError('Error fetching courses. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const courseSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Career and Placements",
    "description": "Boost your career with SkillzVerse Placement Assistance. Get expert guidance, interview prep, and top company connections for guaranteed career growth.",
    "url": "https://skillzverse.com/career-placement-assistance",
    "numberOfItems": courses.length,
    "itemListElement": courses.map((course, index) => ({
      "@type": "Course",
      "position": index + 1,
      "name": "Career and Placements",
      "description": "Boost your career with SkillzVerse Placement Assistance. Get expert guidance, interview prep, and top company connections for guaranteed career growth.",
      "provider": {
        "@type": "Organization",
        "name": "Skillzverse",
        "sameAs": "https://skillzverse.com"
      }
    }))
  };

  return (
    <div>
      <Helmet>
      <title>Career and placement assistance | Skillzverse</title>

      <meta
        name="description"
        content="Boost your career with SkillzVerse Placement Assistance. Get expert guidance, interview prep, and top company connections for guaranteed career growth."
      />
      <meta
        name="keywords"
        content="Premium Courses, Online Learning, Job Assistance, AI Interviews, Skillzverse"
      />
      <meta property="og:title" content="Placement Assistance & Career Support | SkillzVerse" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://skillzverse.com/career-placement-assistance" />
      <meta property="og:image" content="https://skillzverse.com/images/premium-banner.jpg" />

      <link rel="canonical" href="https://skillzverse.com/career-placement-assistance" />

      <script type="application/ld+json">
        {JSON.stringify(courseSchema)}
      </script>
    </Helmet>

      {loading ? (
        <ClipLoader color="#333333" loading={loading} size={30} id="clipLoader" />
      ) : courses?.length > 0 ? (
        <div className="course-main-container">

          <div
            style={{
              color: '#0B89C2',
              padding: '20px',
              borderRadius: '12px',
              fontSize: 'clamp(14px, 2vw, 16px)',
              fontWeight: 500,
              fontFamily: "'Nunito', sans-serif",
              marginTop: '50px',
              marginLeft: 'auto',
              marginRight: 'auto',
              boxShadow: '0 4px 7px rgba(0,0,0,0.2)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              textAlign: 'left',
              lineHeight: '1.5',
            }}
          >
            <p style={{ marginBottom: '12px' }}>
              🎯 <strong>Heads-Up:</strong>&nbsp;This course might lead to internship offers —{' '}
              <em>both paid and unpaid</em> — based on your engagement and results.
            </p>

            <div
              style={{
                background: '#f1faff',
                border: '1px dashed #0B89C2',
                borderRadius: '10px',
                padding: '12px 16px',
              }}
            >
              <p style={{ margin: '0 0 8px 0', fontWeight: 600 }}>
                ✅ Job Assistance:
              </p>
              <ul style={{ margin: 0, paddingLeft: '20px' }}>
                <li>
                  <strong>AI Interview Attempts:</strong> After completing a course, you will get up to 5 AI-powered interview attempts.
                </li>
                <li>
                  <strong>Certificate &amp; Job Support:</strong> Once you clear the interview, you will receive your certificate and get job assistance for up to 10 job opportunities.
                </li>
                <li>
                  <strong>Extended Support:</strong> If you are unable to secure a job after these 10 opportunities, you can renew by paying a nominal fee, and we will provide another 10 job assistance opportunities.
                </li>
              </ul>
            </div>
          </div>

          <CourseTemplate
            coursesData={courses}
            pageTitle={t("Premium Courses")}
            error={error}
          />

        </div>
      ) : (
        <div className="course-not-found-main-container">
          {message}
        </div>
      )}
    </div>
  );
};

export default PremiumCourses;
